module.exports = __webpack_public_path__ + "img/img4.0cbb1a99.svg";